var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriveThru(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 77.83,
    cy: 86.93,
    rx: 19.04,
    ry: 3.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 32.02,
    cy: 82.93,
    rx: 26.94,
    ry: 3.44
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "18.47,41.56 12.4,54.11 51.91,54.11 46.43,41.56  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.4,59.21h5.73c0,0,4,0,5.75,5.35H8.07C8.07,64.56,8.25,64.2,8.4,59.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.21,59.21h-5.74c0,0-4,0-5.76,5.36h11.97C56.68,64.57,56.68,64.26,56.21,59.21z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "25.46,61.09 38.63,61.09 36.9,65.79 27.2,65.79  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.94,52.14c0,0,0.22-1.41-3.15-2.43L6.5,49.2c-1.13,0-1.36,1.24-1.36,2.57c0,1.33,0.28,1.65,1.36,2.25 C6.5,54.02,11.28,55.5,12.94,52.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.11,52.14c0,0-0.22-1.41,3.15-2.43l3.29-0.51c1.13,0,1.36,1.24,1.36,2.57c0,1.33-0.28,1.65-1.36,2.25 C57.55,54.02,52.76,55.5,51.11,52.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.47,74.87h-8.28v4.52c0,1.06,1.09,1.91,2.43,1.91h3.42c1.34,0,2.43-0.86,2.43-1.91V74.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.51,74.87h-8.67v4.52c0,1.06,1.14,1.91,2.54,1.91h3.58c1.4,0,2.54-0.86,2.54-1.91V74.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.94,74.87c-3,0-5.33-2.33-5.33-5.61l0.02-4.99c0-5.37,1.18-9.51,6.14-9.51h36.78 c4.96,0,6.14,4.14,6.14,9.51v4.77c0,3.28-2.31,5.84-5.31,5.84H12.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 33.87,
    className: "st4",
    width: 16.27,
    height: 19.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 76.88,
    y1: 52.47,
    x2: 76.88,
    y2: 34.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 85.32,
    y1: 34.67,
    x2: 85.32,
    y2: 52.47
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "69.43,7.8 69.43,56.87 61.94,56.87 61.94,63.07 64.91,63.07 64.91,84.8 69.43,84.8 92.87,84.8  92.87,7.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.4,22.96V7.83c-3.73,0-9.3,7.95-9.3,15.12v6.18h0.25c0.22-1,1.49-1.73,2.4-1.73 c0.83,0,2.08,0.61,2.37,1.46c0.29-0.86,1-1.46,1.83-1.46c0.91,0,2.18,0.74,2.4,1.73l0.07,1.53v-7.71H69.4z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 64.91,
    y1: 63.07,
    x2: 72.23,
    y2: 63.07
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveThru);
export default __webpack_public_path__ + "static/media/Drive_Thru.02a77c9e614225fe4daa80527c63efca.svg";
export { ForwardRef as ReactComponent };